module.exports = __webpack_public_path__ + "static/media/html.525f317f.svg";